<template>
  <div
    v-loading="loading"
    class="applicant"
    :element-loading-text="loadingText"
    element-loading-custom-class="csv-loading"
  >
    <div v-if="contractStatus === 3" class="message message-warning mb-x3">
      <div>現在、サービスのご利用が終了しているため、一部の機能に制限がかかっています。</div>
      <div>ご利用を再開したい場合は、弊社担当にご連絡いただくか、右下のチャットからお問い合わせください。</div>
    </div>
    <direct-message-dialog ref="directMessageDialog" />
    <serial-code-dialog ref="serialCodeDialog" />
    <applicant-random-dialog ref="applicantRandomDialog" />
    <applicant-reset-dialog ref="applicantResetDialog" />
    <applicant-import-dialog ref="applicantImportDialog" />
    <direct-message-history-dialog ref="directMessageHistoryDialog" />
    <lottery-page-dialog ref="lotteryPageDialog" />
    <div class="applicant-head mb-x2">
      <div layout="row" layout-align="space-between-start">
        <applicant-filter />
        <div v-if="campaignPrize && campaignPrize.id" class="campaign-info">
          <div layout layout-align="space-between-start">
            <span class="mr-x3"> 応募者数: {{ formatNumber(campaignPrize.applicantsCount) }} </span>
            <span>候補者数: {{ formatNumber(campaignPrize.candidateCount) }}</span>
          </div>
          <div layout layout-align="space-between-start">
            <span class="mr-x3">
              当選者数: {{ formatNumber(campaignPrize.winnerCount) }} (残り{{
                formatNumber(campaignPrize.maxWinnerCount - campaignPrize.winnerCount)
              }})
            </span>
            <span>回答者数: {{ formatNumber(campaignPrize.responderCount) }}</span>
          </div>
        </div>
      </div>
      <transition name="advance-filter-transition">
        <applicant-advance-filter v-if="showAdvanceFilter" class="mt-x2" />
      </transition>
    </div>
    <div v-if="firstLoaded" v-loading="isLoading" class="card">
      <div class="mb-x2" layout layout-align="space-between-center">
        <div layout>
          <el-button v-if="campaignPrize.isWebInstantwin" type="primary" @click="openLotteryPageDialog">
            <div class="lottery-page-button">
              <img class="web-icon-img" src="@/client/assets/images/twitter-web-instant-circle.svg" />
              当落選ページの管理
            </div>
          </el-button>
          <el-button
            type="default"
            :disabled="!campaign.account || !campaign.account.id || !applicants.length || contractStatus === 3"
            @click="openApplicantRandomDialog"
          >
            <i class="mdi mdi-dice-multiple" />ランダム抽選
          </el-button>
          <el-button
            type="default"
            :disabled="
              !campaign.account || !campaign.account.id || !campaignPrize.applicantsCount || contractStatus === 3
            "
            @click="openDirectMessageDialog"
          >
            <i class="mdi mdi-email" />
            当選メッセージの管理
          </el-button>
          <el-button
            type="default"
            :disabled="
              !campaign.account ||
              !campaign.account.id ||
              contractStatus === 3 ||
              (campaign.type === 'keyword' && !campaignPrize.applicantsCount)
            "
            @click="openSerialCodeDialog"
          >
            <i class="mdi mdi-ticket" />
            シリアルコードの管理
          </el-button>
          <el-dropdown class="ml-x1" trigger="click" @command="openDialog">
            <el-button class="dropdown-button" type="default" :disabled="!applicants.length || contractStatus === 3">
              <i class="mdi mdi-playlist-play mr-x1" />
              一括操作
              <i class="mdi mdi-chevron-down dropdown-arrow ml-x3" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in actionDialogs"
                :key="item.value"
                :command="item.value"
                :divided="item.divided"
                :disabled="item.disabled"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-tooltip placement="top" content="CSVダウンロード">
          <csv-download v-if="!error" :download="downloadCsv" :disabled="!applicants.length" text="" />
        </el-tooltip>
      </div>
      <div class="mb-x1" layout layout-align="space-between-center">
        <span class="mr-x3 caption"> 総件数 : {{ formatNumber(options.total) }}件 </span>
        <div class="view-type-button">
          <el-button-group class="ml-x1">
            <el-button
              :disabled="!applicants.length || contractStatus === 3"
              :type="viewType === 'list' ? 'primary' : 'default'"
              @click="changeViewType('list')"
              ><i class="mdi mdi-view-list" />一覧</el-button
            >
            <el-button
              :disabled="!applicants.length || contractStatus === 3"
              :type="viewType === 'grid' ? 'primary' : 'default'"
              @click="changeViewType('grid')"
              ><i class="mdi mdi-view-module" />グリッド</el-button
            >
          </el-button-group>
        </div>
      </div>
      <div v-if="error">
        <div class="message message-error">
          データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
        </div>
      </div>
      <div v-else>
        <!-- リポスト・引用系は開催前と応募収集URL未設定のあいだ案内文を表示し、収集開始後は応募者の有無で切り替える -->
        <template v-if="isRepostEntryCampaign">
          <div class="message message-info mb-x2" v-if="isRepostCampaignBeforeStart">
            このキャンペーンは、{{
              campaignStartDatetime
            }}から開催されます。<br />キャンペーン開始後、応募収集URLを設定してください。設定されるまで応募は収集されません。<br />応募収集URLを設定すると、応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
          </div>
          <div class="message message-info mb-x2" v-else-if="isRepostCampaignBeforeCollect">
            応募収集URLを設定すると、応募の収集を開始します。設定されるまで応募は収集されません。<br />応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
          </div>
          <div v-else-if="!applicants.length" class="message message-info">
            条件に該当する応募者のデータがありません。
          </div>
        </template>
        <template v-else>
          <div v-if="isWaitingApplicantCollection">
            <div class="message message-info message-center">
              <b>応募が収集されるまで、しばらくお待ちください。</b><br /><br />
              ポスト、メンション・返信は30分間隔で収集されます。
              <div class="mt-x2"><img class="wait-image" src="@/client/assets/images/time.png" /></div>
            </div>
          </div>
          <div v-else-if="!applicants.length" class="message message-info">
            条件に該当する応募者のデータがありません。
          </div>
        </template>
        <div v-if="applicants.length">
          <applicant-table
            v-if="viewType === 'list'"
            :applicants="applicants"
            :options="options"
            :campaign-account-id="campaignAccountId"
            :campaign-id="campaign.id"
            :campaign-start-datetime="campaign.startDatetime"
            :campaign-type="'keyword'"
            @paging="onPaging"
            @sorting="onSorting"
            @change_flag="changeFlag"
            @open_message_history="openMessageHistory"
            @open_applicant_drawer="openApplicantDrawer"
            @change_ng="changeNgAccount"
          />
          <applicant-grid
            v-if="viewType === 'grid'"
            :applicants="applicants"
            :options="options"
            :campaign-type="'keyword'"
            :is-dm-sending="isDmSending"
            sns-type="twitter"
            @paging="onPaging"
            @change_flag="changeFlag"
            @open_message_history="openMessageHistory"
            @change_ng="changeNgAccount"
          /><DrawerTwitterApplicant :campaign-type="'keyword'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import Icon from '@/client/components/_atoms/Icon.vue'
import { DrawerTwitterApplicant } from '@/client/components/_organisms'
import api from '@/client/core/api'
import util from '@/client/core/util'
import { isRepostEntryActionType } from '@/client/features/campaigns/utils/campaignUrlSettingTarget'
import {
  RepostCollectionAlertState,
  resolveRepostCollectionAlertState
} from '@/client/features/campaigns/utils/repostCollectionAlert'
import ApplicantAdvanceFilter from '@/client/features/twitter_applicant/applicant_advance_filter'
import ApplicantFilter from '@/client/features/twitter_applicant/applicant_filter'
import ApplicantGrid from '@/client/features/twitter_applicant/applicant_grid'
import ApplicantImportDialog from '@/client/features/twitter_applicant/applicant_import_dialog'
import ApplicantRandomDialog from '@/client/features/twitter_applicant/applicant_random_dialog'
import ApplicantResetDialog from '@/client/features/twitter_applicant/applicant_reset_dialog'
import ApplicantTable from '@/client/features/twitter_applicant/applicant_table'
import DirectMessageDialog from '@/client/features/twitter_applicant/direct_message_dialog'
import DirectMessageHistoryDialog from '@/client/features/twitter_applicant/direct_message_history_dialog'
import LotteryPageDialog from '@/client/features/twitter_applicant/lottery_page_dialog'
import SerialCodeDialog from '@/client/features/twitter_applicant/serial_code_dialog'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'
import { isBeforeNttAaaSwitchover } from '@/common/utils'
import { TApplicant } from '@/typings/api/twitter_applicants.type'

export default defineComponent({
  components: {
    CsvDownload,
    ApplicantAdvanceFilter,
    ApplicantFilter,
    ApplicantGrid,
    ApplicantImportDialog,
    ApplicantRandomDialog,
    ApplicantResetDialog,
    ApplicantTable,
    DirectMessageDialog,
    SerialCodeDialog,
    DirectMessageHistoryDialog,
    DrawerTwitterApplicant,
    LotteryPageDialog,
    Icon
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      viewType: 'list'
    }
  },
  async created() {
    this.setParams({ campaignId: this.$route.params.campaignId, prizeId: this.$route.params.prizeId })
    // キャンペーンデータを取得
    await this.fetchCampaign()
    await this.fetchCampaignPrize()
    await this.fetchApplicants()

    if (this.campaign && this.campaign.id && this.currentGroupId !== this.campaign.groupId) {
      this.setCurrentGroup(this.campaign.groupId)
    }

    this.setBreadcrumb([
      {
        name: 'キャンペーン一覧',
        link: '/campaigns'
      },
      {
        name: this.campaign.title,
        link: `/twitter_campaigns/${this.campaign.id}/prizes`,
        iconName: this.campaign.account ? this.campaign.account.name : '削除されたアカウント',
        iconUrl: this.campaign.account.pictureUrl,
        iconType: this.campaign.snsType,
        isIcon: true
      },
      {
        name: this.campaignPrize.name,
        link: null
      }
    ])
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup.id,
      contractStatus: state => state.currentGroup.contractStatus
    }),
    ...mapState(useTwitterApplicantStore, {
      params: state => state.params,
      applicants: state => state.applicants,
      isDmSending: state => state.isDmSending,
      campaign: state => state.campaign ?? {},
      campaignAccountId: state => (state.campaign && state.campaign.account ? state.campaign.account.id : 0),
      campaignPrize: state => state.campaignPrize ?? {},
      options: state => ({
        total: state.total,
        pagingNo: state.params.pagingNo,
        limitCount: state.params.limitCount,
        sortBy: state.params.sortBy
      }),
      firstLoaded: state => state.firstLoaded,
      error: state => state.error,
      showAdvanceFilter: state => state.showAdvanceFilter,
      isLoading: state => state.isLoading
    }),

    isBeforeNttAaaSwitchover,

    /**
     * 応募収集の待機メッセージを表示するか
     * NTT AAA 切替後はポスト・ポストメディア・メンションが30分間隔の収集となるため、いずれも待機対象とする
     */
    isWaitingApplicantCollection() {
      if (this.campaign.lastProcessedDatetime !== null || this.applicants.length) {
        return false
      }

      const entryActionType = this.campaign.setting?.entryActionType

      if (this.isBeforeNttAaaSwitchover) {
        return entryActionType === 'tweet'
      }

      return ['tweet', 'tweet_media', 'mention'].includes(entryActionType)
    },

    campaignStartDatetime() {
      return moment(this.campaign.startDatetime).format('YYYY年MM月DD日 HH:mm')
    },

    isRepostEntryCampaign() {
      return this.campaign.type === 'keyword' && isRepostEntryActionType(this.campaign.setting?.entryActionType)
    },

    repostCollectionAlertState() {
      return resolveRepostCollectionAlertState({
        type: this.campaign.type,
        entryActionType: this.campaign.setting?.entryActionType,
        status: this.campaign.status,
        hasTweetPostUrl: Boolean(this.campaign.hasTweetPostUrl)
      })
    },

    isRepostCampaignBeforeStart() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_START
    },

    isRepostCampaignBeforeCollect() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_COLLECTION
    },

    actionDialogs() {
      return [
        {
          label: '候補者インポート',
          value: 'import_candidate'
        },
        {
          label: '当選者インポート',
          value: 'import_winner',
          disabled: this.isDmSending
        },
        {
          label: '回答者インポート',
          value: 'import_responder'
        },
        {
          label: '候補者解除',
          value: 'reset_candidate',
          divided: true
        },
        {
          label: '当選者解除',
          value: 'reset_winner',
          disabled: this.isDmSending
        },
        {
          label: '回答者解除',
          value: 'reset_responder'
        }
      ]
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useSystemStore, ['setCurrentGroup']),
    ...mapActions(useNavbarStore, ['setBreadcrumb']),
    ...mapActions(useTwitterApplicantStore, [
      'reset',
      'fetchApplicants',
      'fetchCampaignPrize',
      'fetchCampaign',
      'setParams',
      'updateApplicant',
      'openApplicantDrawer',
      'updateNgAccount'
    ]),

    /**
     * Open dialog
     * @param {string} value
     */
    openDialog(value: string) {
      TrackingService.sendEvent('select:応募一覧（X）|一括操作')

      if (value.indexOf('reset') !== -1) {
        const type = value.replace('reset_', '')
        this.$refs.applicantResetDialog.open(type)
      } else {
        const type = value.replace('import_', '')
        this.$refs.applicantImportDialog.open(type)
      }
    },

    /**
     * ページを変更イベント
     * @param {{ pagingNo: number, limitCount: number }} page ページ
     */
    onPaging(payload: { pagingNo: number; limitCount: number }) {
      this.setParams(payload)
      util.scrollToTop()
    },

    /**
     * ソートを変更イベント
     * @param {{sortBy: string}} payload ソート
     */
    onSorting(payload: { sortBy: string }) {
      const sortBy = payload.sortBy
      if (this.params.sortBy === sortBy) {
        return
      }
      this.setParams({ sortBy })
    },

    openMessageHistory(payload) {
      this.$refs.directMessageHistoryDialog.open(payload.applicantId)
    },

    openLotteryPageDialog() {
      this.$refs.lotteryPageDialog.open(this.campaign.id, this.campaignPrize.id)
    },

    /**
     * フラグ変更処理
     * @param {{type: string, value: any}} payload
     */
    async changeFlag(payload) {
      const type = payload.type
      const value = payload.value
      let result

      switch (type) {
        case 'winner':
          result = await this.updateApplicant(value)

          // 当選数に空きがない場合はエラーメッセージを表示
          if (result.error && result.error.type === 'MAX_WINNER_COUNT_OVER') {
            this.showError('残り当選数に空きがありません。')
            return
          }

          if (result.error && result.error.type === 'DM_SENDING_IN_PROGRESS') {
            this.showError('DM送信中のため当選者フラグを変更できません。', 'DM送信が終了してから再度お試しください。')
            return
          }

          // エラーがある場合はエラーメッセージを表示
          if (!result.data) {
            this.showError('当選者の保存に失敗しました')
          }
          break

        case 'responder':
          result = await this.updateApplicant(value)

          // エラーがある場合はエラーメッセージを表示
          if (!result.data) {
            this.showError('回答者の保存に失敗しました')
          }
          break

        case 'candidate':
          result = await this.updateApplicant(value)
          // エラーがある場合はエラーメッセージを表示
          if (!result.data) {
            this.showError('候補者の保存に失敗しました')
          }
          break
      }
    },

    /**
     * NGアカウント追加/解除処理
     * @param {{screenName: string, isNg: boolean, ngApplicantId: number | null}} payload
     */
    async changeNgAccount(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      const result = await this.updateNgAccount(payload)
      if (!result || !result.data) {
        this.$notify({
          title: 'NGアカウントの更新に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
      }
    },

    /**
     * グリッドの切替
     * @param {string} viewType
     */
    changeViewType(viewType: string) {
      TrackingService.sendEvent(`click:応募一覧（X）|${viewType === 'list' ? '一覧' : 'グリッド'}`)

      this.viewType = viewType
    },

    /**
     * エラーを表示
     * @params {string} title タイトル
     * @param {string} message
     */
    showError(title: string, message: string) {
      if (!message) {
        this.$notify({
          title,
          customClass: 'danger',
          duration: 5000
        })
      } else {
        this.$notify({
          title,
          message,
          customClass: 'danger',
          duration: 5000
        })
      }
    },

    /**
     * メッセージの一括ダイアログを開く
     */
    openDirectMessageDialog() {
      TrackingService.sendEvent('click:応募一覧（X）|当選メッセージの管理')

      this.$refs.directMessageDialog.open(this.campaignPrize.id, this.campaign.id)
    },

    /**
     * シリアルコードの管理ダイアログを開く
     */
    openSerialCodeDialog() {
      TrackingService.sendEvent('click:応募一覧（X）|シリアルコードの管理')

      this.$refs.serialCodeDialog.open(this.campaignPrize.id, this.campaign.id)
    },

    /**
     * ランダム抽選ダイアログを開く
     */
    openApplicantRandomDialog() {
      TrackingService.sendEvent('click:応募一覧（X）|ランダム抽選')

      this.$refs.applicantRandomDialog.open()
    },

    /**
     * CSVファイルに追加するフォロワー数、ポスト数、累計参加数、累計当選数のフィルター条件のテキスト
     * @param {number} overNumber 以上の数
     * @param {number} lessNumber 未満の数
     * @param {string} conditionText フィルター条件のテキスト
     */
    createFiterConditionText(overNumber: any, lessNumber: any, conditionText: string) {
      // フォロワー数、ポスト数、累計参加数、累計当選数のフィルター条件が未入力の場合はリターン
      if ((overNumber === undefined && lessNumber === undefined) || (overNumber === '' && lessNumber === '')) {
        return
      }
      return (
        conditionText +
        String(overNumber).replace(/(\d)(?=(\d{3})+\b)/g, '$1,') +
        '~' +
        String(lessNumber).replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
      )
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      TrackingService.sendEvent('click:応募一覧（X）|CSVダウンロード')

      try {
        const applicants: TApplicant[] = await this.getApplicantsForCsv()
        if (!applicants.length) {
          return { error: 'ERROR_LOADING' }
        }

        const filename = `campaign_applicants_${moment().format('YYYY_MM_DD')}`

        // フィルター条件がある場合CSVファイルの一番上に追加する
        const filterCondition = []
        let filterConditionPostType = ''
        let filterConditionIsFollowing = ''
        let filterConditionIsWinner = ''
        let filterConditionIsResponder = ''
        let filterConditionIsWarning = ''
        let filterConditionIsJoinDatetime = ''
        let filterConditionIsProfileImage = ''
        let filterConditionIsDescription = ''
        const params = this.params

        // ポスト種別でフィルター条件がある場合は、フィルター条件に追加する
        switch (params.postType) {
          case 'tweet':
            filterConditionPostType = 'ポスト'
            break
          case 'retweet':
            filterConditionPostType = '公式リポスト'
            break
          case 'quote_tweet':
            filterConditionPostType = '引用'
            break
          case 'mention':
            filterConditionPostType = 'メンション'
            break
          case 'reply':
            filterConditionPostType = '返信'
            break
        }

        if (filterConditionPostType) {
          filterCondition.push([filterConditionPostType])
        }

        // フォローでフィルター条件がある場合は、フィルター条件に追加する
        switch (params.isFollowing) {
          case 1:
            filterConditionIsFollowing = 'フォローあり'
            break
          case 0:
            filterConditionIsFollowing = 'フォローなし'
            break
        }

        if (filterConditionIsFollowing) {
          filterCondition.push([filterConditionIsFollowing])
        }

        // 当選者でフィルター条件がある場合は、フィルター条件に追加する
        switch (params.isWinner) {
          case 1:
            filterConditionIsWinner = '当選フラグあり'
            break
          case 0:
            filterConditionIsWinner = '当選フラグなし'
            break
        }

        if (params.isInstantwinWinner) {
          filterConditionIsWinner = ''
        }

        if (filterConditionIsWinner) {
          filterCondition.push([filterConditionIsWinner])
        }

        // 回答者でフィルター条件がある場合は、フィルター条件に追加する
        switch (params.isResponder) {
          case 1:
            filterConditionIsResponder = '回答フラグあり'
            break
          case 0:
            filterConditionIsResponder = '回答フラグなし'
            break
        }

        if (filterConditionIsResponder) {
          filterCondition.push([filterConditionIsResponder])
        }

        // フォロワー数フィルター条件がある場合、フィルター条件に追加する
        const filterConditionFollowerCount = this.createFiterConditionText(
          params.followersCount[0],
          params.followersCount[1],
          'フォロワー数'
        )

        if (filterConditionFollowerCount) {
          filterCondition.push([filterConditionFollowerCount])
        }

        // ポスト数フィルター条件がある場合、フィルター条件に追加する
        const filterConditionTweetsCount = this.createFiterConditionText(
          params.tweetsCount[0],
          params.tweetsCount[1],
          'ポスト数'
        )

        if (filterConditionTweetsCount) {
          filterCondition.push([filterConditionTweetsCount])
        }

        // 累計参加数フィルター条件がある場合、フィルター条件に追加する
        const filterConditiontotalCampaignEntryCount = this.createFiterConditionText(
          params.totalCampaignEntryCount[0],
          params.totalCampaignEntryCount[1],
          '累計参加数'
        )

        if (filterConditiontotalCampaignEntryCount) {
          filterCondition.push([filterConditiontotalCampaignEntryCount])
        }

        // 累計当選数フィルター条件がある場合、フィルター条件に追加する
        const filterConditiontotalCampaignWinningCount = this.createFiterConditionText(
          params.totalCampaignWinningCount[0],
          params.totalCampaignWinningCount[1],
          '累計当選数'
        )

        if (filterConditiontotalCampaignWinningCount) {
          filterCondition.push([filterConditiontotalCampaignWinningCount])
        }

        // アカウント名検索でフィルター条件がある場合は、フィルター条件に追加する
        if (params.accountName) {
          filterCondition.push(['アカウント名' + '[' + params.accountName + ']'])
        }

        // 警告アカウントでフィルター条件がある場合は、フィルター条件に追加する
        switch (params.isWarning) {
          case 1:
            filterConditionIsWarning = '警告フラグあり'
            break
          case 0:
            filterConditionIsWarning = '警告フラグなし'
            break
        }

        if (filterConditionIsWarning) {
          filterCondition.push([filterConditionIsWarning])
        }

        // アカウント開設日でフィルター条件がある場合は、フィルター条件に追加する
        if (params.isJoinDatetime === 1) {
          filterConditionIsJoinDatetime = 'キャンペーン開始より前'
        }

        if (filterConditionIsJoinDatetime) {
          filterCondition.push([filterConditionIsJoinDatetime])
        }

        switch (params.isProfileImage) {
          case 1:
            filterConditionIsProfileImage = '設定あり'
            break
          case 0:
            filterConditionIsProfileImage = '設定なし'
            break
        }

        if (filterConditionIsProfileImage) {
          filterCondition.push([filterConditionIsProfileImage])
        }

        switch (params.isDescription) {
          case 1:
            filterConditionIsDescription = '入力あり'
            break
          case 0:
            filterConditionIsDescription = '入力なし'
            break
        }

        if (filterConditionIsDescription) {
          filterCondition.push([filterConditionIsDescription])
        }

        // 凍結アカウントでフィルター条件がある場合は、フィルター条件に追加する
        let filterConditionIsSuspendedAccount = ''
        switch (params.isSuspendedAccount) {
          case 1:
            filterConditionIsSuspendedAccount = '凍結フラグあり'
            break
          case 0:
            filterConditionIsSuspendedAccount = '凍結フラグなし'
            break
        }

        if (filterConditionIsSuspendedAccount) {
          filterCondition.push([filterConditionIsSuspendedAccount])
        }

        const csvData = []

        // フィルター条件がある場合は、一番最初の行にフィルター条件を追加する
        if (filterCondition.length > 0) {
          csvData.push(['フィルター条件:', filterCondition.join('/')])
        }

        csvData.push([
          'No',
          'アカウントID',
          'アカウント名',
          'アカウントスクリーン名',
          'アカウントURL',
          'アカウント画像',
          'アカウント説明文',
          'アカウント開設日',
          '応募日時',
          'ポスト種別',
          '投稿内容',
          '投稿画像URL',
          '投稿URL',
          'フォロワー',
          'フォロー',
          'FF比率',
          'ポスト',
          '応募数',
          '累計参加数',
          '累計当選数',
          'フォロー中',
          'ポジティブアカウント',
          'ネガティブアカウント',
          'NGアカウント',
          '凍結中',
          '候補者',
          '当選者',
          'web当選者',
          '回答者',
          'メッセージ件数'
        ])

        // CSVデータを格納
        applicants.forEach((applicant, index) => {
          let postType = ''
          switch (applicant.post.postType) {
            case 'tweet':
              postType = 'ポスト'
              break
            case 'retweet':
              postType = '公式リポスト'
              break
            case 'quote_tweet':
              postType = '引用'
              break
            case 'mention':
              postType = 'メンション'
              break
            case 'reply':
              postType = '返信'
              break
          }
          csvData.push([
            index + 1,
            applicant.accountId,
            applicant.name,
            applicant.screenName,
            'https://x.com/' + applicant.screenName,
            applicant.pictureUrl,
            applicant.description ? applicant.description.replace(/(\r\n|\n|\r)/gm, '') : '',
            formatDatetime(applicant.joinDatetime),
            formatDatetime(applicant.post.publishDatetime),
            postType,
            applicant.post.message ? applicant.post.message.replace(/(\r\n|\n|\r)/gm, '') : '',
            applicant.post.mediaUrl,
            'https://x.com/' + applicant.accountId + '/status/' + applicant.post.id,
            applicant.followersCount,
            applicant.followsCount,
            formatNumber(applicant.followsRate),
            applicant.tweetsCount,
            applicant.postsCount,
            applicant.totalCampaignEntryCount,
            applicant.totalCampaignWinningCount,
            applicant.isFollowing,
            applicant.isPositive,
            applicant.isWarning,
            applicant.isNg,
            applicant.isSuspendedAccount,
            applicant.isCandidate,
            applicant.isWinner,
            applicant.isWebInstantwinWinner,
            applicant.isResponder,
            applicant.messagesCount
          ])
        })

        return {
          filename,
          data: csvData
        }
      } catch {
        return { error: 'ERROR_LOADING' }
      }
    },

    /**
     * CSV用応募者一覧を取得
     */
    async getApplicantsForCsv() {
      this.loading = true
      const { total } = this.options

      this.getTextLoading(0, total)

      const params = Object.assign({}, this.params, {
        pagingNo: 1,
        limitCount: 1000,
        forCsv: 1
      })

      let totalResults = []
      let fetchedCount = 0

      // 1000件ごとに取得する
      const maxPages = Math.ceil(total / 1000)
      for (let pageIndex = 0; pageIndex < maxPages && fetchedCount < total; pageIndex++) {
        try {
          const result = await api.get('/twitter_applicants', { params })

          if (!result || !result.data || !result.data.applicants) {
            throw new Error('ERROR_LOADING')
          }

          const applicants = result.data.applicants
          if (applicants.length === 0) {
            break
          }

          totalResults = totalResults.concat(applicants)
          fetchedCount += applicants.length

          // 進捗表示を更新
          const displayCount = Math.min(fetchedCount, total)
          this.getTextLoading(displayCount, total)

          params.pagingNo = params.pagingNo + 1

          if (applicants.length < 1000) {
            break
          }
        } catch {
          this.loading = false

          return
        }
      }

      this.loading = false
      return totalResults.slice(0, total)
    },

    /**
     * CSVダウンロードの時、進捗を表示する
     * @params {number} acquiredNumber
     * @params {number} totalNumber
     */
    getTextLoading(acquiredNumber: number, totalNumber: number) {
      this.loadingText = `CSVファイルの作成中です。しばらくお待ちください。\n ${acquiredNumber}件 / ${totalNumber}件`
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // 応募者ストアをリセット
    this.reset()
    next()
  }
})
</script>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.applicant {
  .csv-loading {
    .el-loading-spinner {
      top: 40vh;

      .el-loading-text {
        white-space: pre-line;
      }
    }
  }
}

.view-type-button {
  height: $spacing-unit * 4;
}

.message-center {
  text-align: center;
}

.wait-image {
  max-width: $spacing-unit * 13;
}
</style>
<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-info {
  position: relative;
  margin-top: $spacing-unit;

  .last-processe-datetime {
    position: absolute;
    top: $spacing-unit * 3;
  }
}

.el-dropdown {
  .dropdown-button {
    width: $spacing-unit * 20;

    .dropdown-arrow {
      color: $disabled-color;
    }
  }
}

.lottery-page-button {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
  justify-content: center;
}

.web-icon-img {
  width: $round * 5;
  height: $round * 5;
  margin: 0;
  filter: brightness(0) invert(1);
}

.advance-filter-transition-enter-active,
.advance-filter-transition-leave-active {
  transition: all 0.2s ease;
}

.advance-filter-transition-enter,
.advance-filter-transition-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>
